import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {ButtonBuiltInControl} from '../ButtonBuiltInControl';

import {ButtonTextStyleAndFontColorControlLabels} from './ButtonTextStyleAndFontColorControlLabels';

export abstract class ButtonTextStyleAndFontColorBuiltInControl extends ButtonBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.BLOCK_BUTTON].TEXT_STYLE_AND_COLOR;
  }

  public getLabels(): ButtonTextStyleAndFontColorControlLabels | undefined {
    return undefined;
  }
}
